export default "__VITE_ASSET__DXb3Oz_q__"